<template>
  <div class="containerSelect_PFormSelectOrder">
    <p-drop-down-container v-model="pussOption">
      <template v-slot:content>
        <div :class="variantCop">
          <div class="iconSort_PFormSelectOrder">
            <PIcon icon="IconSort" :size="13" class="icon_PFormSelectOrder"></PIcon>
          </div>
          <div>{{ selectedText }}</div>
          <div class="iconSortSelected_PFormSelectOrder" v-if="selectedItemValue.selected != ''">
            <PIcon
              :icon="'Icon' + selectedItemValue.orderDirection"
              :size="12"
              color="#d7b000"
              class="icon_PFormSelectOrder"
            ></PIcon>
          </div>
          <div class="expand_moreSelect">
            <PIcon icon="expand_less" type="material" color="#ffd102" v-if="pussOption"></PIcon>
            <PIcon icon="expand_more" type="material" color="#ffd102" v-else></PIcon>
          </div>
        </div>
      </template>

      <div class="optionsSelect_PFormSelectOrder">
        <div
          v-for="(option, index) in options"
          :key="index"
          @click="selectItem(option.value)"
          :class="giveMeClass(option.value)"
        >
          <span>{{ option.text }}</span>
          <span class="optionIcon_PFormSelectOrder">
            <PIcon
              :icon="'Icon' + selectedItemValue.orderDirection"
              :size="12"
              color="#d7b000"
              v-if="selectedItemValue.selected === option.value"
            ></PIcon>
          </span>
        </div>
      </div>
    </p-drop-down-container>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SelectOrderType, SelectType } from "./pFormSelect.types";
import PDropDownContainer from "../PDropDownContainer/PDropDownContainer.vue";
import PIcon from "../PIcon/PIcon.vue";

@Component({
  components: {
    PDropDownContainer,
    PIcon,
  },
})
export class PFormSelectOrder extends Vue {
  @Prop({ required: true }) value!: SelectOrderType;
  @Watch("value", { immediate: true })
  onChangeValue(): void {
    if (this.value) {
      this.selectedItemValue = Object.assign(this.value);
    }
  }
  @Prop({ required: true }) options!: SelectType[];
  @Prop({ required: false, default: "Select an option" }) placeholder!: string;
  @Prop({ required: false, default: "button" }) variant!: string;

  selectedItemValue: SelectOrderType = { selected: "", orderDirection: "DESC" };
  pussOption = false;
  get variantCop(): string {
    let returnTemp: string = "inputSelect_PFormSelectOrder_" + this.variant;
    if (this.variant === "button" && this.selectedItemValue.selected != "") {
      returnTemp = returnTemp + " borderSelected_PFormSelectOrder";
    }
    return returnTemp;
  }
  get selectedText(): string {
    const optionFind = this.options.find((opt) => opt.value == this.selectedItemValue.selected);
    if (optionFind) {
      return optionFind.text;
    } else {
      return this.placeholder;
    }
  }
  selectItem(itemValue: any): void {
    this.selectedItemValue.selected = itemValue;
    if (this.selectedItemValue.orderDirection === "DESC") {
      this.selectedItemValue.orderDirection = "ASC";
    } else {
      this.selectedItemValue.orderDirection = "DESC";
    }
    this.$emit("input", this.selectedItemValue);
    this.$emit("change", this.selectedItemValue);
    this.pussOption = false;
  }
  giveMeClass(itemValue: any): string {
    if (this.selectedItemValue.selected == itemValue) {
      return "itemOption_PFormSelectOrder itemSelectSelected";
    } else {
      return "itemOption_PFormSelectOrder itemSelect";
    }
  }
}
export default PFormSelectOrder;
</script>
<style scoped>
.containerSelect_PFormSelectOrder {
  position: relative;
}
.inputSelect_PFormSelectOrder_button {
  object-fit: contain;
  border-radius: 16px;
  border: solid 1px #e8e8e8;
  background-color: #fff;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #6f6f6f;
  padding: 6px 5px 6px 12px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  margin-left: 10px;
  height: 32px;
  cursor: pointer;
}
.icon_PFormSelectOrder {
  margin-top: -3px;
}
.iconSort_PFormSelectOrder {
  padding-right: 10px;
}
.iconSortSelected_PFormSelectOrder {
  padding-left: 5px;
}
.optionsSelect_PFormSelectOrder {
  display: flex;
  flex-direction: column;
}
.optionIcon_PFormSelectOrder {
  padding-left: 10px;
}
.itemOption_PFormSelectOrder {
  display: flex;
  justify-content: space-between;
}

.itemSelect,
.itemSelectSelected {
  padding-left: 3px;
  border-bottom: solid 1px rgb(151, 151, 151, 0.13);
  object-fit: contain;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 3;
  letter-spacing: normal;
  cursor: pointer;
  white-space: nowrap;
}
.itemSelectSelected {
  color: #d7b000;
}
.itemSelect:hover {
  background-color: rgb(151, 151, 151, 0.13);
}

.expand_moreSelect span {
  font-size: 18px !important;
  color: #ffd102;
  margin-top: 4px;
  margin-left: 5px;
}
.borderSelected_PFormSelectOrder {
  border: solid 1px #d7b000;
}
</style>
